/**
 * Routines for displaying the stockist map
 */

/**
 * Internal dependencies
 */
import load from './load';
import mapsapi from './mapsapi';

/**
 * Find containers and load the maps in them
 */
const map = () => {
	const maps = document.querySelectorAll< HTMLElement >(
		'.stockist-map-container'
	);

	if ( maps.length ) {
		load( maps );
	}
};

export default map;
export { mapsapi };
